export default {
  connection: null,

  connected: false,
  participants: {},
  devices: {
    video: null,
    audio: null
  },
  messages: [],

  isPriestOnShrift: false
}
